<template>
    <Layout>
        <router-view></router-view>
    </Layout>
</template>
  
<script>
import Layout from "@layouts/main";

export default {
    components: { Layout },
    name: "wh",
    data() {
        return {};
    },
    mounted() {
        let menu = [
            {
                name: "wh_overview",
                params: { hash: this.$route.params.hash }
            },
            { name: "wh_tunnels", params: { name:'wh_tunnels' } },
            { name: "wh_keys", params: { name:'wh_keys' } },
        ];

        this.$root.$options.appStore.dispatch("pushSubMenuItems", menu);
    }
};
</script>